/**
 * A mapping of the old Dataset IDs to the current Dataset ID.
 * This is used to migrate old dataset links to the new dataset UUIDs for pre-defined datasets.
 *
 * @note On load, the Dataset Details page will perform the transformation and redirect.
 * @note The mapping supports sequential migrations (e.g. A -> B, B -> C)
 * and will resolve to the latest ID.
 * @type {Array<[original_id: string, latest_id: string]>}
 */
export const DATASET_ID_MIGRATION = [
  ['CTD2_001', '090bb7e2-ca4c-59fc-84cf-ad0fb1492818'],
  ['CTD2_002', 'aa42f6fd-5fe2-53d2-87d9-d7045f702447'],
  ['CTD2_003', '0427851f-f353-5b11-bbc8-60706a61e13e'],
  ['CTD2_004', '1ba9e0a7-9ee8-5abd-9d5a-7110e83a64ca'],
  ['CTD2_005', 'f9f9cfa3-f551-5b32-b583-0eecc93eaa41'],
  ['CTD2_006', '0983de6c-d25b-5ede-bc53-243bce757ca3'],
  ['CTD2_007', 'b0f88c6d-2f2f-5298-aeb4-e79fedaf39bd'],
  ['CTD2_008', '5746a0f1-d51d-5380-b997-18b7fa90e976'],
  ['CTD2_009', '3c0ed39c-ab7c-59d1-b33a-56e5407e179c'],
  ['CTD2_010', 'ab5702e2-acc4-5234-86ee-d9723794e4db'],
  ['CTD2_011', '2c691c23-9aad-5245-8490-903f5105fb3c'],
  ['CTD2_012', '9fd9a631-54e1-5a03-b7df-130b6a73f24e'],
  ['CTD2_013', 'b21c581f-c9cf-527a-ba94-86f666d0ea40'],
  ['CTD2_014', '4f2e21ed-c146-57e1-8b43-44100d24da30'],
  ['CTD2_015', '63b9949e-cbb8-5a33-b3bd-bd4c41e3d9aa'],
  ['CTD2_016', 'cd18c045-7d16-5417-bb30-8d22c6923e4f'],
  ['CTD2_017', 'd1bb7a71-50b7-567d-a5d9-cfabc0f7aa3c'],
  ['CTD2_018', 'aeaaa54e-b287-5fa3-bbe0-e48e4b5381ef'],
  ['CTD2_019', '2299a744-d784-5161-a0a7-358a986542d6'],
  ['CTD2_020', '2eda1357-dd1d-57ae-8025-14033aa28721'],
  ['CTD2_021', 'f0881bf1-8d6d-57b5-80b8-d38e2cc819a8'],
  ['CTD2_022', '13b57cca-84a3-52d9-9803-0af076e6c638'],
  ['CTD2_023', '87083791-5b1b-5578-a63d-22a99697b9f9'],
  ['CTD2_024', 'cff79459-5419-5047-b9b6-ee8015c69fa5'],
  ['CTD2_025', 'd8a32533-a0f5-53ac-801b-b5806de0fe47'],
  ['CTD2_026', '48158a61-91b8-552d-87a0-53435090159a'],
  ['CTD2_027', '8297d6f6-3df5-5b1e-b78b-fdf938fae8c1'],
  ['CTD2_028', '776f48cd-bcfc-50d5-94b2-3a8c6331f457'],
  ['CTD2_029', '59b869ff-d61d-5091-8d82-7ab477ff8272'],
  ['CTD2_030', '5ac3a8db-c92c-508e-93a5-63f9584d3857'],
  ['CTD2_031', 'a778bdb1-8528-5f8c-8ce0-fb6378c51b89'],
  ['CTD2_032', '323d93ba-2c12-5cab-b80c-464234ba818f'],
  ['CTD2_033', '2d7d0d4d-d32b-512b-beff-d85c9f8065bd'],
  ['CTD2_034', 'a28167ae-65d9-5f06-908f-a4e899d3d90e'],
  ['CTD2_035', 'c0df65fc-d07c-515e-9a30-a7bf310b6e49'],
  ['CTD2_036', 'd355fb6a-ab98-5c56-a0ac-7c8d16ae8974'],
  ['CTD2_037', 'b4858ee5-6ec1-58fb-9d00-75e561182d0d'],
  ['CTD2_038', '395c6ac4-067e-580d-a5e9-21da0631e193'],
  ['CTD2_039', 'bb4b40a1-63db-5bfe-8df1-97d0703a2b01'],
  ['CTD2_040', '8e53681d-4f98-58f0-bba7-f2e26f3ac55a'],
  ['CTD2_041', '3bb05020-cd4d-5219-85f6-8462d20d8d90'],
  ['CTD2_042', 'f8307dd7-8a9c-5478-8929-7d1ffc392f2d'],
  ['CTD2_043', '6638a720-6e51-574d-963b-25c1aaf32af1'],
  ['CTD2_044', 'a9689b68-e4e1-5739-a595-f7751fc13084'],
  ['CTD2_045', '2324aa09-4c13-57ac-a105-0625c711edc0'],
  ['CTD2_046', 'e2a2c4e4-da7c-5431-b323-0f47ff40bbe0'],
  ['CTD2_047', 'be2c4d7f-5496-5198-ae83-31c41c0d0061'],
  ['CTD2_048', 'f5105086-af37-5d87-953b-302ceb6e60ad'],
  ['CTD2_049', '6da186e1-bb02-5824-a36f-b51bfb19734b'],
  ['CTD2_050', '56326aad-8988-5dbb-85b4-968ff723555d'],
  ['CTD2_051', 'a1afb930-a710-51a7-a64b-5ef80cc01924'],
  ['CTD2_052', 'a25513f1-a966-5b23-b908-dfa9d3bf88dd'],
  ['CTD2_053', '69f7e180-8d5e-50e5-8f1d-e612d13c0ebc'],
  ['CTD2_054', '2e6263bd-614a-5ba4-94dc-d1b7d9e77bf5'],
  ['CTD2_055', 'b61a6955-b4a7-59dd-8f4d-c9d8e59bd042'],
  ['CTD2_056', '5db626d7-0499-58af-a748-d2819e597be1'],
  ['CTD2_057', '5a8c618c-8292-5370-873a-ca03b5d95249'],
  ['CTD2_058', '481175ed-5990-5c4a-bb71-da8c837b8bcc'],
  ['CTD2_059', '0745c9e9-adf2-5492-876f-e2e76edc4672'],
  ['CTD2_060', '49f337d6-0d51-5e82-afb0-1688a5cd4812'],
  ['CTD2_061', '9f91eadd-775a-5e8a-918d-caf36cfe2a88'],
  ['CTD2_062', '05a2c38f-df3a-5b74-8679-ab237137739b'],
  ['CTD2_063', '9208d82d-76e9-560a-85e1-b5ca4a2e54a7'],
  ['CTD2_064', 'ab0ba510-55e4-58ab-b246-271f5fb51105'],
  ['CTD2_065', '2a55f3f8-3c9a-56a2-8b13-9a6706fd8030'],
  ['CTD2_066', '7d356db1-e1de-5dcc-809c-97b4fbd7cb48'],
  ['CTD2_067', '2a81df6b-99bf-5921-bd57-ca99db8dd2b3'],
  ['CTD2_068', '8fee876f-051a-5cd9-ac05-65adb1dbe8d0'],
  ['CTD2_069', '616b1730-6d0a-5775-9e37-1be6e0f75e49'],
  ['CTD2_070', '9ee725ef-362e-5100-9466-4b9ff65e4fb7'],
  ['CTD2_071', '9effe3b9-521a-51ed-b8a5-ebc3b55e7c66'],
  ['CTD2_072', '015ff3f0-a306-53d1-a3c3-a1c65a9f01cf'],
  ['CTD2_073', '7331908a-9179-5d2b-ad09-c59f6eaa10b8'],
  ['CTD2_074', 'e4e4817a-ea3d-5fa6-ad93-5a3df855dba7'],
  ['CTD2_075', '38bf1ccf-44dd-56bc-8cd1-dd56952d722c'],
  ['CTD2_076', '2d7b644f-8d51-5876-895d-d649c381257d'],
  ['CTD2_077', 'b1305c07-74d3-54e7-aed9-2db4c1d290f5'],
  ['CTD2_078', 'd0ea71a3-46b2-57dc-bc93-6a62effb8718'],
  ['CTD2_079', '64b3aab6-809b-5c88-9277-a9b612d87190'],
  ['CTD2_080', '6edc6d02-f1b8-585d-876b-d7226ce1e1fb'],
  ['CTD2_081', '0509e8bb-c3c7-5e4d-a29a-e55bd126b90c'],
  ['CTD2_082', '588e153c-185e-59e5-922f-3400a77eac22'],
  ['CTD2_083', '46d13456-ac72-576c-9fe1-1ba9c775edbe'],
  ['CTD2_084', 'd9618156-8127-5805-84bd-7bb13ce2af93'],
  ['CTD2_085', '2ff9e6a2-f31f-5b5c-9d1a-cbeac2a663af'],
  ['CTD2_086', 'b393e110-73d6-59b6-9b37-06198fd1bde6'],
  ['CTD2_087', '0042a765-6b50-58eb-a0fb-a5009c44a82b'],
  ['CTD2_088', '7853b10f-20cb-54c4-9396-663807be4c20'],
  ['CTD2_089', 'a96e3a52-b734-58ec-b263-58f8ad1191bf'],
  ['CTD2_090', '1a8d0573-54aa-5d34-8e1a-66883220004d'],
  ['CTD2_091', '8d968426-f9d3-579c-8c52-dda94641b4f3'],
  ['CTD2_092', 'dc84c73f-8d98-5914-9c8f-210f0e2640be'],
  ['CTD2_093', '40612cea-e9aa-5643-82d1-2b7975671cc8'],
  ['CTD2_094', '9c1c83d3-0eb1-5eb8-a54f-24cd9130278e'],
  ['CTD2_095', '1fe65f01-d906-5ae1-a36b-a894b435a98d'],
  ['CTD2_096', '52512ccb-5c8a-5dee-abdd-466d16215a46'],
  ['CTD2_097', '7bd6cfc6-a52e-5f38-b940-1f0e233b5a11'],
  ['CTD2_098', '0d5c0b26-6a7f-5847-bae9-09ddb8dbfaf7'],
];

export default DATASET_ID_MIGRATION;
